import SubPage from '../subpages/SubPage';
import { Container, Row } from 'react-bootstrap';
import Pill from '../components/Pill';
const Trekking = () => {
  const pillInfo = {
    margin: '1rem 1rem 0rem 1rem',
    width: '8rem',
  };
  const longPillInfo = {
    margin: '1rem',
    width: '9rem',
  };
  const title = '언텍트 트레킹';
  const parent_link = 'trekking';
  const side_list = [
    ['1', '대회 안내'],
    ['2', '참가자 모집'],
    ['3', '시상'],
    ['4', '기념품'],
    ['5', '코스안내'],
  ];
  const bg_info = {
    link: 'https://user-images.githubusercontent.com/46194004/123917479-ce698400-d9bd-11eb-9599-975e219cee76.png',
    text: title,
  };
  return (
    <div style={{ minHeight: '70rem' }}>
      <SubPage
        title={title}
        parent_link={parent_link}
        side_list={side_list}
        isOnePage={true}
        background_info={bg_info}
      />
      <Container fluid className="col-lg-8 offset-lg-3">
        <Container id="1">
          <h2 className="pt-5 mb-5">대회 안내</h2>
          <Pill
            title="일시"
            content="2021.10.2.(토) ~ 16.(토) / 15일간"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <p className="under-pill-text">- 각 코스별 인증기념품 소진 시까지</p>
          <Pill
            title="운영시간"
            content="해당 기간 08:00 ~ 17:00"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <p className="under-pill-text">
            - 코로나 19 확산방지를 위해 개별 접수·출발
          </p>
          <p className="under-pill-text">
            - 대청호마라톤대회 전용 앱 '대덕달리미'로 인증
          </p>
          <Pill
            title="운영종목"
            content="5개코스 / 금강 해피로드, 대청호 둘레산길, 계족산 탐방길, 계족산 산성길, 두메마을 조망길"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="참가인원"
            content="코스별 2,000명(중복신청 가능)"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
        </Container>
        <br />
        <Container id="2">
          <h2 className="mt-5">참가자 모집</h2>
          <br />
          <Pill
            title="신청기간"
            content=" ~ 10.15.(금) 17:00"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="신청방법"
            content="홈페이지(www.dcmarathon.or.kr)"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="모집인원"
            content="코스별 2,000명(중복신청 가능)"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="참가비"
            content="없음"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
        </Container>
        <br />

        <Container id="3">
          <h2 className="mt-5">시상</h2>
          <br />
          <Pill
            title="행운상"
            content="➀ 5개 코스 통합 완주자 중 완주 번호가 20단위 해당자"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <p className="under-pill-text">
            ➁ 1개 코스 이상 완주자를 대상으로 추첨(총 50명)
          </p>
          <p className="under-pill-text">
            ※ 상품은 2만원 상당의 지역 농산물 및 공산품, 생활용품으로 지급
          </p>
          <Pill
            title="대덕e로움 상"
            content="대덕 e로움 소지자 포인트 지급"
            margin={pillInfo.margin}
            titleWidth="10rem"
          />
          <p className="under-pill-text">
            3개 코스 완주자(3천원), 4개 코스 완주자(4천원), 5개 코스
            완주자(5천원)
          </p>
          <p className="under-pill-text">
            ※ 지급방법 : 대회종료 후 우편발송 및 포인트 충전
          </p>
          <br className="d-block d-md-none" />
        </Container>
        <br />

        <Container id="4">
          <h2 className="mt-5">기념품</h2>
          <br />
          <Pill
            title="지급 대상"
            content="참가신청자로 코스별 완주 인증자"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Pill
            title="기념품"
            content="코스별 완주뱃지 / 코스별 1종"
            margin={pillInfo.margin}
            titleWidth={pillInfo.width}
          />
          <Row>
            <div className="mt-3">
              <img
                src="/badge.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
          </Row>
          {/* <Row>
            <div className="mt-3" style={{ width: '10rem' }}>
              <img
                src="/뱃지 이미지.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
            <div className="mt-3" style={{ width: '10rem' }}>
              <img
                src="/뱃지2.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
            <div className="mt-3" style={{ width: '10rem' }}>
              <img
                src="/뱃지3.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
            <div className="mt-3" style={{ width: '10rem' }}>
              <img
                src="/뱃지4.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
            <div className="mt-3" style={{ width: '10rem' }}>
              <img
                src="/뱃지5.png"
                alt="뱃지 이미지"
                style={{ maxWidth: '100%' }}
              />
            </div>
          </Row>

          <p className="under-pill-text" style={{ fontSize: '0.9rem' }}>
            위 이미지는 연출된 이미지로 추후 수정 예정
          </p> */}
        </Container>
        <br />
        <br />

        <Container id="5">
          <h2 className="mb-4">코스안내</h2>
          <br />
          <h2 className="mb-4">제 1코스</h2>
          <Pill
            title="코스특징"
            content="대청수상레포츠센터 - 보조댐 - 삼정취수장 - 미호교 - 해피로드 -
            댐물홍보관"
            margin={pillInfo.margin}
            titleWidth={longPillInfo.width}
          />
          <Container className="mb-5">
            <img
              src="/금강해피로드.jpg"
              alt="online_marathon"
              style={{ maxWidth: '100%' }}
            />
          </Container>
          <h2 className="mb-4">제 2코스</h2>
          <Pill
            title="코스특징"
            content="댐물홍보관 - 대청호둘레산길 - 캠핑장 - 공도교 - 영지산 - 삼정 취수장"
            margin={pillInfo.margin}
            titleWidth={longPillInfo.width}
          />
          <Container className="mb-5">
            <img
              src="/대청호둘레산길.jpg"
              alt="online_marathon"
              style={{ maxWidth: '100%' }}
            />
          </Container>
          <h2 className="mb-4">제 3코스</h2>
          <Pill
            title="코스특징"
            content="봉황마당 - 계족산 - 임도3거리 - 절고개 - 비래사(옥류각) - 임도 - 봉황마당"
            margin={pillInfo.margin}
            titleWidth={longPillInfo.width}
          />
          <Container className="mb-5">
            <img
              src="/계족산탐방길.jpg"
              alt="online_marathon"
              style={{ maxWidth: '100%' }}
            />
          </Container>
          <h2 className="mb-4">제 4코스</h2>
          <Pill
            title="코스특징"
            content="관리사무소 - 산림욕장(무대) - 계족산성(계단)입구 - 계족산성 - 성재산 - 임도3거리"
            margin={pillInfo.margin}
            titleWidth={longPillInfo.width}
          />
          <p className="under-pill-text">
            - 임도(황톳길) - 계족산성(계단)입구 - 산림욕장(무대) - 관리사무소
          </p>
          <Container className="mb-5">
            <img
              src="/계족산-산성길.jpg"
              alt="online_marathon"
              style={{ maxWidth: '100%' }}
            />
          </Container>
          <h2 className="mb-4">제 5코스</h2>
          <Pill
            title="코스특징"
            content="이현동 공영주차장 - 심곡천길 - 마을유래비 - 임도 - 이현동방향 - 비오개천길 - 이현동 공영주차장"
            margin={pillInfo.margin}
            titleWidth={longPillInfo.width}
          />
          <Container className="mb-5">
            <img
              src="/두메마을조망길.jpg"
              alt="online_marathon"
              style={{ maxWidth: '100%' }}
            />
          </Container>
        </Container>
      </Container>
    </div>
  );
};
export default Trekking;
